module.exports = __webpack_public_path__ + "img/Shruti Dhawan.11725293.jpg";